<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Konfigurasi Sistem Eksternal"
        class="card-wrapper"
        >

        <v-card>
        <v-card-title>
            
            <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari Konfigurasi berdasarkan Nama"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
            <v-spacer></v-spacer>

            <v-btn
                color="primary"
                class="mr-4"
                @click="addItem()"
            >
              Tambah
            </v-btn>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="pengaturans"
            :search="search"
            :options.sync="tableOptions"
            :loading="isLoading"
            loading-text="Memuat data..."
            no-data-text="Data Pengaturan tidak ditemukan"
            no-results-text="Data Pengaturan tidak ditemukan"
            hide-default-footer
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            />
          </template>
          <template v-slot:item.aksi="{ item }">
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="primary" dark @click="editItem(item)"><v-icon small class="mr-1"> mdi-eye </v-icon>Detail</v-btn>
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="orange" dark @click="updateItem(item)"><v-icon small class="mr-1"> mdi-pencil </v-icon>Ubah</v-btn>
            <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="red" dark @click="deleteItem(item)"><v-icon small class="mr-1"> mdi-delete </v-icon>Hapus</v-btn>
          </template>
        </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" max-width="500px">
          <v-card class="card-modal">
            <v-card-title>
              <span class="headline">Hapus Pengaturan Eksternal</span>
            </v-card-title>
  
            <v-card-text>
              Apakah anda yakin ingin menghapus data Pengaturan Eksternal {{namaDelete}}?
            </v-card-text>
  
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn @click="close">Batal</v-btn>
              <v-btn color="primary" dark @click="confirmDelete">Hapus</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
    
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";

export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["search", "tableOptions"],
  restoreAfterLoad: ["tableOptions"],
  data () {
    return {
      pengaturans: [],
      search: '',
      tableOptions: {},
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      currentPeran: "",
      isLoading: true,
      dialog: false,
      namaDelete: null,
      idDelete: null,
      totalData: 0,
      headers: [
       
        { text: 'Nama', 
          sortable: false,
          value: 'nama_app' 
        },
        { text: 'Secret Key', 
          sortable: false,
          value: 'secret_key' 
        },
        { text: 'CallBack', 
          sortable: false,
          value: 'call_back' 
        },
        { text: 'Aksi',
          sortable: false,
          value: 'aksi',
          width: '300px'
        },
      ],
    }
  },
  created() {
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    console.log("loading")
    this.getData();
  },
  methods: {
    getData() {
      this.isLoading = true;
      console.log(this.isLoading);
      apiServer
        .get("/pengaturan-eksternal/all")
        .then(response => {
          this.pengaturans = response.data.data;
          this.isLoading = false;
          console.log("loaded")
          console.log(this.pengaturans)
          this.currentPeran = localStorage.getItem("currentPeran")
          this.totalData = response.data.total
          if(localStorage.getItem("updateSuccess") != null) {
            this.showSnackbar("orange", localStorage.getItem("updateSuccess"));
            this.close()
            localStorage.removeItem("updateSuccess")
          }
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },

    addItem(){
      this.$router.push('/pengaturan-eksternal/tambah');
    },

    editItem(item){
      console.log(item)
      this.$router.push('/pengaturan-eksternal/detail/' + item.app_id);
    },
    updateItem(item){
      console.log(item)
      this.$router.push('/pengaturan-eksternal/ubah/' + item.app_id);
    },
     deleteItem(val) {
      console.log("delete " +val.nama_app)
      this.dialog = true
      this.namaDelete = val.nama_app
      this.idDelete = val.app_id
    },
    confirmDelete() {
      apiServer
          .delete("/pengaturan-eksternal/delete/" + this.idDelete)
          .then(response => {
            this.showSnackbar("orange", "Hapus Organisasi berhasil dilakukan");
            this.close()
            this.getData()
          })
          .catch(error => {
            console.log("There was an error:", error.response);
            this.showSnackbar(
                "error",
                error.response.data.message
            );
          });
    },
    close() {
      this.namaDelete = ""
      this.idDelete = 0
      this.dialog = false;
    },
  }
}
</script>